import { panelColors } from "./colors";

const panelStyles = {
    borderRadius: '4px',
    ...panelColors,
}

export default panelStyles;